// Only reviewed, published locales belong here. Node audits and Parcel use the same loaders.
// Node exposes JSON through a default export; Parcel can return the catalogue directly.
const catalogFromImport = imported => imported.default ?? imported;

export const catalogLoaders = Object.freeze({
  en: async () => catalogFromImport(await import('./messages/en.json', { with: { type: 'json' } })),
  es: async () => catalogFromImport(await import('./messages/es.json', { with: { type: 'json' } })),
  'pt-BR': async () => catalogFromImport(await import('./messages/pt-BR.json', { with: { type: 'json' } })),
  fr: async () => catalogFromImport(await import('./messages/fr.json', { with: { type: 'json' } })),
  ar: async () => catalogFromImport(await import('./messages/ar.json', { with: { type: 'json' } })),
  de: async () => catalogFromImport(await import('./messages/de.json', { with: { type: 'json' } })),
});
